export const tablesInfo = [
  {
    id: "PREPCO",
    code: "pco",
    filter: "ARTPCO",
    key: "PAIPCO",
    value: "PREPCO",
  },
  {
    id: "TAX",
    code: "ari",
    filter: "ARTARI",
    key: "PAIARI",
    value: "IMPARI",
  },
  {
    id: "ALMART",
    code: "sto",
    filter: "ARTSTO",
    key: "ALMSTO",
    erase: ["ARTSTO", "ALMSTO"],
  },
  {
    id: "PREART",
    code: "lta",
    filter: "ARTLTA",
    key: "PAILTA",
    subKey: "TARLTA",
    erase: ["ARTLTA", "PAILTA"],
  },
  {
    id: "OFEART",
    code: "ofe",
    filter: "ARTOFE",
    key: "PAIOFE",
    erase: ["ARTOFE", "PAIOFE", "ACTOFE"],
  },
  {
    id: "FORART",
    code: "fo0",
    filter: "SEVFO0",
    key: "",
    erase: ["SEVFO0", "SUCFO0"],
  },
  {
    id: "COMMART",
    code: "coz",
    filter: "ARTCOZ",
    key: "",
  },
];
